/* */ 
"use strict";
Object.defineProperty(exports, "__esModule", {value: true});
exports.showNotificationList = exports.showFuturePaymentDetails = exports.showAccountTransactionDetails = exports.showEnrollAccounts = exports.showTransferForm = exports.showTransferDragAndDropForm = exports.showSnapCash = exports.showPaymentAgreementList = exports.showMyAdvisor = exports.showMessageList = exports.showLoginForm = exports.showLoanTransactionList = exports.showLoanTerms = exports.showLoanList = exports.showLanguageSelector = exports.showKidPaymentForm = exports.showFindUs = exports.showDialog = exports.showToast = exports.showEFakturaPaymentForm = exports.showEFakturaList = exports.showEFakturaDragAndDropForm = exports.showEditFavoriteAccounts = exports.showCurrencyConverter = exports.showCreditCardTransactionList = exports.showCreditCardList = exports.showBlockCard = exports.showApprovePayments = exports.showAgreementSelector = exports.showAccountTransactionList = exports.showAccountTerms = exports.showAccountList = exports.setAgreement = exports.getFavouriteAccounts = exports.getAdvertisingIdentifier = exports.doLogout = exports.changeLanguage = exports.getAvailableLanguages = void 0;
require('core-js/modules/es6.string.iterator');
require('core-js/modules/es6.array.from');
require('core-js/modules/es6.regexp.to-string');
require('core-js/modules/es7.symbol.async-iterator');
require('core-js/modules/es6.symbol');
require('core-js/modules/web.dom.iterable');
require('core-js/modules/es6.promise');
require('core-js/modules/es6.object.to-string');
var _parser = require('./parser');
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0,
        arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
var callSDCNative = function callSDCNative(funcName) {
  for (var _len = arguments.length,
      args = new Array(_len > 1 ? _len - 1 : 0),
      _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return new Promise(function(res) {
    if (window.sdc && window.sdc[funcName]) {
      var _window$sdc;
      var parsed = args.map(function(arg) {
        return (0, _parser.tryStringify)(arg);
      });
      var resp = (_window$sdc = window.sdc)[funcName].apply(_window$sdc, _toConsumableArray(parsed));
      res((0, _parser.tryParse)(resp));
    } else {
      throw new Error({msg: "Function ".concat(funcName, " not found")});
    }
  });
};
var FUNCTIONS = {
  changeLanguage: 'changeLanguage',
  doLogout: 'doLogout',
  getAdvertisingIdentifier: 'getAdvertisingIdentifier',
  getAvailableLanguages: 'getAvailableLanguages',
  getFavouriteAccounts: 'getFavouriteAccounts',
  extendRestapiSession: 'extendRestapiSession',
  setAgreement: 'setAgreement',
  showAccountList: 'showAccountList',
  showAccountTerms: 'showAccountTerms',
  showAccountTransactionList: 'showAccountTransactionList',
  showAgreementSelector: 'showAgreementSelector',
  showApprovePayments: 'showApprovePayments',
  showBlockCard: 'showBlockCard',
  showCreditCardList: 'showCreditCardList',
  showCreditCardTransactionList: 'showCreditCardTransactionList',
  showCurrencyConverter: 'showCurrencyConverter',
  showEditFavoriteAccounts: 'showEditFavoriteAccounts',
  showEFakturaDragAndDropForm: 'showEFakturaDragAndDropForm',
  showEFakturaList: 'showEFakturaList',
  showEFakturaPaymentForm: 'showEFakturaPaymentForm',
  showDialog: 'showDialog',
  showFindUs: 'showFindUs',
  showKidPaymentForm: 'showKidPaymentForm',
  showLanguageSelector: 'showLanguageSelector',
  showLoanList: 'showLoanList',
  showLoanTerms: 'showLoanTerms',
  showLoanTransactionList: 'showLoanTransactionList',
  showLoginForm: 'showLoginForm',
  showMessageList: 'showMessageList',
  showMyAdvisor: 'showMyAdvisor',
  showPaymentAgreementList: 'showPaymentAgreementList',
  showSnapCash: 'showSnapCash',
  showToast: 'showToast',
  showTransferDragAndDropForm: 'showTransferDragAndDropForm',
  showTransferForm: 'showTransferForm',
  showEnrollAccounts: 'showEnrollAccounts',
  showFuturePaymentDetails: 'showFuturePaymentDetails',
  showAccountTransactionDetails: 'showAccountTransactionDetails',
  showNotificationList: 'showNotificationList'
};
var getAvailableLanguages = function getAvailableLanguages() {
  return callSDCNative(FUNCTIONS.getAvailableLanguages);
};
exports.getAvailableLanguages = getAvailableLanguages;
var changeLanguage = function changeLanguage() {
  for (var _len2 = arguments.length,
      args = new Array(_len2),
      _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.changeLanguage].concat(args));
};
exports.changeLanguage = changeLanguage;
var doLogout = function doLogout() {
  for (var _len3 = arguments.length,
      args = new Array(_len3),
      _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.doLogout].concat(args));
};
exports.doLogout = doLogout;
var getAdvertisingIdentifier = function getAdvertisingIdentifier() {
  return callSDCNative(FUNCTIONS.getAdvertisingIdentifier);
};
exports.getAdvertisingIdentifier = getAdvertisingIdentifier;
var getFavouriteAccounts = function getFavouriteAccounts() {
  return callSDCNative(FUNCTIONS.getFavouriteAccounts);
};
exports.getFavouriteAccounts = getFavouriteAccounts;
var setAgreement = function setAgreement() {
  for (var _len4 = arguments.length,
      args = new Array(_len4),
      _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.setAgreement].concat(args));
};
exports.setAgreement = setAgreement;
var showAccountList = function showAccountList() {
  return callSDCNative(FUNCTIONS.showAccountList);
};
exports.showAccountList = showAccountList;
var showAccountTerms = function showAccountTerms(accountEntityKey) {
  return callSDCNative(FUNCTIONS.showAccountTerms, accountEntityKey);
};
exports.showAccountTerms = showAccountTerms;
var showAccountTransactionList = function showAccountTransactionList(accountEntityKey) {
  return callSDCNative(FUNCTIONS.showAccountTransactionList, accountEntityKey);
};
exports.showAccountTransactionList = showAccountTransactionList;
var showAgreementSelector = function showAgreementSelector() {
  return callSDCNative(FUNCTIONS.showAgreementSelector);
};
exports.showAgreementSelector = showAgreementSelector;
var showApprovePayments = function showApprovePayments() {
  return callSDCNative(FUNCTIONS.showApprovePayments);
};
exports.showApprovePayments = showApprovePayments;
var showBlockCard = function showBlockCard() {
  return callSDCNative(FUNCTIONS.showBlockCard);
};
exports.showBlockCard = showBlockCard;
var showCreditCardList = function showCreditCardList() {
  return callSDCNative(FUNCTIONS.showCreditCardList);
};
exports.showCreditCardList = showCreditCardList;
var showCreditCardTransactionList = function showCreditCardTransactionList(creditCardEntityKey) {
  return callSDCNative(FUNCTIONS.showCreditCardTransactionList, creditCardEntityKey);
};
exports.showCreditCardTransactionList = showCreditCardTransactionList;
var showCurrencyConverter = function showCurrencyConverter() {
  return callSDCNative(FUNCTIONS.showCurrencyConverter);
};
exports.showCurrencyConverter = showCurrencyConverter;
var showEditFavoriteAccounts = function showEditFavoriteAccounts() {
  return callSDCNative(FUNCTIONS.showEditFavoriteAccounts);
};
exports.showEditFavoriteAccounts = showEditFavoriteAccounts;
var showEFakturaDragAndDropForm = function showEFakturaDragAndDropForm() {
  for (var _len5 = arguments.length,
      args = new Array(_len5),
      _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showEFakturaDragAndDropForm].concat(args));
};
exports.showEFakturaDragAndDropForm = showEFakturaDragAndDropForm;
var showEFakturaList = function showEFakturaList() {
  return callSDCNative(FUNCTIONS.showEFakturaList);
};
exports.showEFakturaList = showEFakturaList;
var showEFakturaPaymentForm = function showEFakturaPaymentForm(accountEntityKey, eFakturaModel) {
  return callSDCNative(FUNCTIONS.showEFakturaPaymentForm, accountEntityKey, eFakturaModel);
};
exports.showEFakturaPaymentForm = showEFakturaPaymentForm;
var showToast = function showToast() {
  return callSDCNative(FUNCTIONS.showToast);
};
exports.showToast = showToast;
var showDialog = function showDialog() {
  for (var _len6 = arguments.length,
      args = new Array(_len6),
      _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showDialog].concat(args));
};
exports.showDialog = showDialog;
var showFindUs = function showFindUs() {
  return callSDCNative(FUNCTIONS.showFindUs);
};
exports.showFindUs = showFindUs;
var showKidPaymentForm = function showKidPaymentForm() {
  for (var _len7 = arguments.length,
      args = new Array(_len7),
      _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showKidPaymentForm].concat(args));
};
exports.showKidPaymentForm = showKidPaymentForm;
var showLanguageSelector = function showLanguageSelector() {
  return callSDCNative(FUNCTIONS.showLanguageSelector);
};
exports.showLanguageSelector = showLanguageSelector;
var showLoanList = function showLoanList() {
  return callSDCNative(FUNCTIONS.showLoanList);
};
exports.showLoanList = showLoanList;
var showLoanTerms = function showLoanTerms(accountEntityKey) {
  return callSDCNative(FUNCTIONS.showLoanTerms, accountEntityKey);
};
exports.showLoanTerms = showLoanTerms;
var showLoanTransactionList = function showLoanTransactionList(accountEntityKey) {
  return callSDCNative(FUNCTIONS.showLoanTransactionList, accountEntityKey);
};
exports.showLoanTransactionList = showLoanTransactionList;
var showLoginForm = function showLoginForm() {
  return callSDCNative(FUNCTIONS.showLoginForm);
};
exports.showLoginForm = showLoginForm;
var showMessageList = function showMessageList() {
  return callSDCNative(FUNCTIONS.showMessageList);
};
exports.showMessageList = showMessageList;
var showMyAdvisor = function showMyAdvisor() {
  return callSDCNative(FUNCTIONS.showMyAdvisor);
};
exports.showMyAdvisor = showMyAdvisor;
var showPaymentAgreementList = function showPaymentAgreementList() {
  return callSDCNative(FUNCTIONS.showPaymentAgreementList);
};
exports.showPaymentAgreementList = showPaymentAgreementList;
var showSnapCash = function showSnapCash() {
  return callSDCNative(FUNCTIONS.showSnapCash);
};
exports.showSnapCash = showSnapCash;
var showTransferDragAndDropForm = function showTransferDragAndDropForm() {
  for (var _len8 = arguments.length,
      args = new Array(_len8),
      _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showTransferDragAndDropForm].concat(args));
};
exports.showTransferDragAndDropForm = showTransferDragAndDropForm;
var showTransferForm = function showTransferForm(accountEntityKey) {
  return callSDCNative(FUNCTIONS.showTransferForm, accountEntityKey);
};
exports.showTransferForm = showTransferForm;
var showEnrollAccounts = function showEnrollAccounts() {
  return callSDCNative(FUNCTIONS.showEnrollAccounts);
};
exports.showEnrollAccounts = showEnrollAccounts;
var showAccountTransactionDetails = function showAccountTransactionDetails() {
  for (var _len9 = arguments.length,
      args = new Array(_len9),
      _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showAccountTransactionDetails].concat(args));
};
exports.showAccountTransactionDetails = showAccountTransactionDetails;
var showFuturePaymentDetails = function showFuturePaymentDetails() {
  for (var _len10 = arguments.length,
      args = new Array(_len10),
      _key10 = 0; _key10 < _len10; _key10++) {
    args[_key10] = arguments[_key10];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showFuturePaymentDetails].concat(args));
};
exports.showFuturePaymentDetails = showFuturePaymentDetails;
var showNotificationList = function showNotificationList() {
  for (var _len11 = arguments.length,
      args = new Array(_len11),
      _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }
  return callSDCNative.apply(void 0, [FUNCTIONS.showNotificationList].concat(args));
};
exports.showNotificationList = showNotificationList;
